// extracted by mini-css-extract-plugin
export var active = "_2t-9";
export var backButton = "_2t-8";
export var clone = "_2t-e";
export var collapseBar = "_2t-k";
export var collapseMode = "_2t-m";
export var collapsed = "_2t-o";
export var dimmed = "_2t-i";
export var dragHandle = "_2t-c";
export var dropdownIcon = "_2t-g";
export var expanding = "_2t-n";
export var hidden = "_2t-x";
export var iconContainer = "_2t-q";
export var iconSwapper = "_2t-w";
export var navItem = "_2t-6";
export var navItemIcon = "_2t-f";
export var navProfile = "_2t-7";
export var notificationCountBadge = "_2t-j";
export var notificationDot = "_2t-r";
export var optionsContainer = "_2t-h";
export var primaryNav = "_2t-0";
export var primaryNavDivider = "_2t-v";
export var primaryNavResizeHandle = "_2t-2";
export var primaryNavResizing = "_2t-1";
export var primaryNavTabSection = "_2t-u";
export var primaryTab = "_2t-p";
export var primaryTabIconBox = "_2t-s";
export var secondaryNav = "_2t-3";
export var selected = "_2t-t";
export var settingsNav = "_2t-4";
export var settingsNavItems = "_2t-5";
export var show = "_2t-d";
export var sideNav = "_2t-l";
export var teamItem = "_2t-a";
export var userProfileItem = "_2t-b";